module.exports = __webpack_public_path__ + "img/pentamar-sa.7c87c2c7.jpg";